import { createContext, useContext, useMemo } from "react";
import { type FieldDataType, type FormContextType, useForm } from "../form";

export type FieldSetContextType = {
  name: string;
  form: FormContextType | undefined;
  field: FieldDataType | undefined;
  mutate(cb: any): any;
};

export const FieldSetContext = createContext<FieldSetContextType | undefined>(undefined);

export function useFieldSet() {
  return useContext(FieldSetContext);
}

export function FieldSet({ children, name, className = "", ...props }) {
  const form = useForm();

  const field = form?.field(name);

  const context = useMemo(
    () => ({
      name,
      form,
      field,
      mutate(cb) {
        return form?.mutateField(name, cb);
      },
    }),
    [name, field, form],
  );

  const { focused } = form?.field(name) || { focused: false };

  return (
    <fieldset className={`border-0 m-0 p-0 mb-4 ${focused ? "[&_input]:border-[#39f]" : ""} ${className}`} {...props}>
      <FieldSetContext.Provider value={context}>{children}</FieldSetContext.Provider>
    </fieldset>
  );
}
